module.exports = __webpack_public_path__ + "img/Pasajero.ttf.3d63ff0.svg";